export const toNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const createPurchaseDataLayerPayload = (payload = {}) => {
  if (payload?.event === 'purchase' && payload?.ecommerce) {
    return {
      ...payload,
      ecommerce: {
        ...payload.ecommerce,
        tax: toNumber(payload.ecommerce.tax),
        shipping: toNumber(payload.ecommerce.shipping),
        value: toNumber(payload.ecommerce.value),
        items: (payload.ecommerce.items || []).map((item) => ({
          ...item,
          price: toNumber(item.price),
          quantity: Number(item.quantity || 0),
        })),
      },
    };
  }

  const {
    orderId,
    email,
    phone,
    value,
    tax,
    shipping,
    currency = 'UAH',
    coupon,
    items = [],
  } = payload;

  return {
    event: 'purchase',
    user_email: email || '',
    user_phone: phone || '',
    ecommerce: {
      currency,
      transaction_id: orderId?.toString?.() || '',
      value: toNumber(value),
      tax: toNumber(tax),
      shipping: toNumber(shipping),
      coupon: coupon || '',
      items: (items || []).map((item) => ({
        item_id: item.product_id?.toString?.() || item.item_id?.toString?.() || '',
        item_group_id: item.product_group_id?.toString?.() || item.item_group_id?.toString?.() || '',
        item_name: item.name || item.item_name || '',
        price: toNumber(item.price_current ?? item.price),
        item_brand: item.brand || item.item_brand || '',
        item_category: item.category || item.item_category || '',
        size: item.size || '',
        color: item.color || '',
        quantity: Number(item.quantity || 0),
      })),
    },
  };
};

export const pushPurchaseEvent = (payload) => {
  const dataLayerPayload = createPurchaseDataLayerPayload(payload);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerPayload);

  return dataLayerPayload;
};
